<template>
    <v-layout
        column
        v-if="!!featureItem"
        class="feature-event"
        mb-0>
        <v-flex xm12>
            <component
                v-if="featureItem && featureItem.canEdit"
                class="feature-event__component"
                :is="determineFeatureItemComponent()"
                :changeComponent="changeComponent"
                v-bind="componentProps"
                keep-alive>
            </component>
        </v-flex>
        <v-flex xm12 mb-3 v-if="featureItem.eventList.length > 0">
            <component
                :is="determineCarouselComponent()"
                :changeComponent="changeCarouselComponent"
                v-bind="componentPropsForCarousel"
                keep-alive>
            </component>
        </v-flex>
    </v-layout>
</template>

<script>
    import { mapActions, mapGetters, mapState } from 'vuex';
    import { storeGetters } from "../../../store/storeGetters.constant";
    import ManageFeatureEvent from "./ManageFeatureEvent";
    import CreateFeatureEvent from "./CreateFeatureEvent";
    import FeatureEventCarousel from "./FeatureEventCarousel";
    import FeatureEventList from "./FeatureEventList";
    import { storeAction } from "../../../store/storeActions.constant";
    import { communityCommonConstant } from "../communityCommon.constant";
    import StatusOverlay from '@/components/StatusOverlay/StatusOverlay';

    export default {
        name: 'FeatureEvent',
        components: {
            FeatureEventList,
            ManageFeatureEvent,
            FeatureEventCarousel,
            CreateFeatureEvent,
            StatusOverlay,
        },
        created() {
            this.getFeatureEvents();
        },
        data() {
            return {
                communityCommonConstant,
                currentComponent: communityCommonConstant.featureEvent.componentNames.manageFeatureEvent,
                currentComponentForCarousel: communityCommonConstant.featureEvent.componentNames.featureEventCarousel,
            };
        },
        methods: {
            ...mapActions({
                getFeatureEvents: `chapter/${storeAction.getFeatureEvents}`,
            }),
            determineFeatureItemComponent() {
                return this.currentComponent;
            },
            determineCarouselComponent() {
                return this.currentComponentForCarousel;
            },
            changeComponent(component) {
                this.currentComponent = component;
            },
            changeCarouselComponent(component) {
                this.currentComponentForCarousel = component;
            },
        },
        computed: {
            ...mapState('actionState', ['actions']),
            ...mapGetters({
                featureItem: `chapter/${storeGetters.featureEvents}`,
                featureEventObject: `chapter/${storeGetters.featureEventObject}`,
            }),
            componentProps() {
                const {
                    featureEventObject,
                    featureItem,
                    changeComponent,
                } = this;
                return this.currentComponent === communityCommonConstant.featureEvent.componentNames.createFeatureEvent ?
                    {
                        featureEventObject,
                        changeComponent,
                        itemCount: featureItem.eventList && featureItem.eventList.length ? Math.max(...featureItem.eventList.map(e => e.order)) : 0,
                    } :
                    {
                        featureItem,
                        changeComponent,
                    };
            },
            componentPropsForCarousel() {
                const { featureEventObject, changeCarouselComponent, featureItem } = this;
                return {
                    featureItem,
                    featureEventObject,
                    changeCarouselComponent,
                    returnOnSave: communityCommonConstant.featureEvent.componentNames.featureEventCarousel,
                };
            },

        },
    };
</script>

<style lang="scss" scoped>
    @import '../../../common/styles/_colors.scss';
    @import "../../../common/styles/_responsive.scss";


</style>
